import React from 'react';

const ModalFailed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    style={{
      width: 52,
      height: 52,
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="52" height="52" fill="#FA5454" rx="26" />
      <rect
        width="28"
        height="28"
        x="12"
        y="12"
        fill="#FA5454"
        stroke="#FFF"
        strokeWidth="2"
        rx="14"
      />
      <g stroke="#FFF" strokeLinecap="round" strokeWidth="2">
        <path d="M21 21l9.183 9.183M30.183 21L21 30.183" />
      </g>
    </g>
  </svg>
);

export default ModalFailed;
